import { PlusThinIcon } from "./PlusThinIcon";

import styles from "./PlusIconButton.module.scss";

interface IPlusIconButtonProps {
    id?: string;
    dataCy?: string;
    disabled?: boolean;
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

/**
 * @deprecated Will be replaced when storybook is merged
 */
function PlusIconButton(props: IPlusIconButtonProps): JSX.Element {
    return (
        <button
            id={props.id}
            onClick={e => props.onClick?.(e)}
            disabled={props.disabled}
            data-cy={props.dataCy}
            className={`${styles.iconButton} ${styles.secondary}`}
        >
            <PlusThinIcon />
        </button>
    );
}

export { PlusIconButton };
